export const environment = {
    version: '1.0.1',
    production: false,
    onlineOnly: false,
    appNameForUrl: 'lots',
    //remoteDataService: 'https://avidii-dev-service-2ison7p7eq-oa.a.run.app',
    // remoteDataService: 'https://q.naatyaguru.api.ngagepower.com',
    //remoteDataService: 'https://qa-toyota-service-gvcryojwcq-el.a.run.app',
    //remoteDataService:'https://prod-toyota-service-oetuva3lra-el.a.run.app',
    //remoteDataService: 'http://localhost:8080',
    //remoteDataService: 'https://qa-gateway-toyota-service-gvcryojwcq-el.a.run.app',
    remoteDataService: 'https://prod-gateway-toyota-service-oetuva3lra-el.a.run.app',

    //tempToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InV1aWQiOjJ9LCJleHAiOjI1MjQ2MDgwMDAsImlhdCI6MTU4NTgxNDk3NiwiYXVkIjoidm5lbyIsImlzcyI6InZuZW8uYXBwenVpLmNvbSJ9.QUq8p6aL_nGtoR2tv7Yl4f2tYclucC7HJMqBZO-8b9A',
    tempToken: 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJleHAiOjMyMjcyNDc2OTQsInV1aWQiOjIsInJpZCI6MiwidGlkIjoxLCJpYXQiOjE2NTA0NDc2OTQsImF1ZCI6InZuZW8iLCJpc3MiOiJ2bmVvLmFwcHp1aS5jb20iLCJzdWIiOiIifQ.TucH6GNMfhdxa91wbpdRYzlJhXE3e9jXXykHXDlLpQEm0aNr_AR70EDq2qTAAaIvdwnWFxp0-Hjte30cBF_S1A',
    linkKey: 'link',
    username: 'username',
    Sync: {
        fireBase: true,
        couch: false,
    },
    firebaseServicesUsed: {
        media: true,
        notification: true,
        chat: true,
        name: 'test'
    },
    chatEndPoints: {
        signUp: "https://q.naatyaguru.api.ngagepower.com/access",
        createChatRoom: "https://q.naatyguru.api.ngagepower.com/chats/chat_rooms",
        pushMessage: "https://q.naatyguru.api.ngagepower.com/chats/chat_rooms/{{chat_room_id}}/chat_messages",
        updateMessageStatus: "https://q.naatyguru.api.ngagepower.com/chats/chat_rooms/{{chat_room_id}}/chat_messages/audience"
    },
    app: 'COACH'

};














































































